import { render, staticRenderFns } from "./GameRechargeResult.vue?vue&type=template&id=5a4b2b70&scoped=true"
import script from "./GameRechargeResult.vue?vue&type=script&lang=js"
export * from "./GameRechargeResult.vue?vue&type=script&lang=js"
import style0 from "./GameRechargeResult.vue?vue&type=style&index=0&id=5a4b2b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b2b70",
  null
  
)

export default component.exports